export default __webpack_public_path__ + "6acc7f6cf127d37633b8b7021eadee95.png";